import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius } from '~styles/theme.stylex';
export const styles = {
  container: {
    maxWidth: "x1ptgtm5",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingTop: "xf6mfmo",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x117aka2",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    textAlign: "x2b8uid",
    $$css: true
  },
  title: {
    marginTop: "xwg69jb",
    marginBottom: "xhbfen4",
    fontSize: "xngnso2",
    $$css: true
  },
  lead: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "x1t84w78",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  confirm: {
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    gap: "x8fetqu",
    rowGap: null,
    columnGap: null,
    width: "xh8yej3",
    $$css: true
  },
  identity: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x1jchvi3",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  warning: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    padding: "x79iv2k",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "x15xno7f",
    color: "xw6893c",
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontSize: "x1dcheo9",
    lineHeight: "x1evy7pa",
    textAlign: "xdpxx8g",
    $$css: true
  },
  disclosure: {
    textAlign: "xdpxx8g",
    marginBottom: "xat24cr",
    $$css: true
  },
  disclosureText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    $$css: true
  },
  list: {
    marginBlock: "x1k89h87",
    marginTop: null,
    marginBottom: null,
    paddingInlineStart: "xjh29tw",
    paddingLeft: null,
    paddingRight: null,
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    $$css: true
  },
  dangerButton: {
    paddingBlock: "x142x9wm",
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "x1yi5t32",
    color: "x6n9e3r",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    boxShadow: "x1hfq7wg",
    fontFamily: "x1qh5nd4",
    fontSize: "x1lkfr7t",
    fontWeight: "xlr2uoh",
    cursor: "x1ypdohk",
    opacity: "xfqoyci",
    $$css: true
  },
  cancelButton: {
    paddingBlock: "xo0yzjp",
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "xjbqb8w",
    color: "x1gonuu0",
    borderWidth: "xmkeg23",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x5hum9n",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontFamily: "x1qh5nd4",
    fontSize: "x1jchvi3",
    fontWeight: "xr323w7",
    cursor: "x1ypdohk",
    $$css: true
  },
  errorText: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    color: "x5d2zeg",
    fontSize: "x1dcheo9",
    $$css: true
  }
};